import * as yup from 'yup';
import { JobStart, JobStatus, TimeZone } from '@/types/api';

const URLRegex =
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/;

const requiredMessage = 'This field is required.';
export const incorrectUrlMessage = 'Enter a valid url.';
const atLeastOneOption = 'Select at least 1 option.';

const isEmptyOrValidUrl = (value): boolean => (value ? URLRegex.test(value) : true);

export const creatJobSchema = yup.object().shape({
  title: yup.string().required(requiredMessage),
  account: yup.string().required(requiredMessage),
  whenToStart: yup.mixed<keyof typeof JobStart>().required(requiredMessage),
  status: yup.mixed<keyof typeof JobStatus>().required(requiredMessage),
  salaryRangeMax: yup.number().min(0).required(requiredMessage),
  salaryRangeMin: yup.number().min(0).required(requiredMessage),
  numberOfDevs: yup.number().min(1).required(requiredMessage),
  developerType: yup.string().required(requiredMessage),
  techs: yup.array().min(1, atLeastOneOption).required(requiredMessage),
  jobLink: yup.string().test('is-url-or-empty', incorrectUrlMessage, isEmptyOrValidUrl),
});

export const jobSchema = yup.object().shape({
  title: yup.string().required(requiredMessage),
  account: yup.string().required(requiredMessage),
  whenToStart: yup.mixed<keyof typeof JobStart>().required(requiredMessage),
  status: yup.mixed<keyof typeof JobStatus>().required(requiredMessage),
  salaryRange: yup.object().shape({
    min: yup.number().min(0).required(requiredMessage),
    max: yup.number().min(0).required(requiredMessage),
  }),
  numberOfDevs: yup.number().min(1).required(requiredMessage),
  timeZone: yup.mixed<keyof typeof TimeZone>().required(requiredMessage),
  timeZoneOverlap: yup.number().required(requiredMessage),
  developerType: yup.string().required(requiredMessage),
  workingTimes: yup.array().of(
    yup.object().shape({
      start: yup.string().required(requiredMessage),
      end: yup.string().required(requiredMessage),
    })
  ),
  techs: yup.array().min(1, atLeastOneOption).required(requiredMessage),
  jobLink: yup.string().test('is-url-or-empty', incorrectUrlMessage, isEmptyOrValidUrl),
});
